/**
 * VAJA COUNTRY REDIRECT (v2.1 — 19/10/26: agrega #from-us al destino)
 *
 * Solo corre en www.vajacases.com (ROW no redirige a nadie).
 * Visitantes de países fuera de USA_COUNTRIES → row.vajacases.com (misma ruta).
 *
 * Cambio vs v1: el país ya no sale solo de localization.country, que devuelve
 * "US" para cualquier país que no tenga Market en la tienda USA. Ahora:
 *   1. Si Liquid da un país distinto de US (país con Market), se usa directo.
 *   2. Si da US, se confirma con /browsing_context_suggestions.json
 *      (país real por IP). Se guarda en sessionStorage para no repetir.
 *
 * Nunca redirige: bots/crawlers, Theme Editor, ni quien tenga redirectOff.
 *
 * Override manual:
 *   #redirectoff → desactiva redirecciones 10 años en ese navegador.
 *   #redirecton  → las vuelve a activar.
 */
(() => {
  'use strict';

  const USA_HOST = 'www.vajacases.com';
  const ROW_HOST = 'row.vajacases.com';
  const REDIRECT_COOKIE = 'redirectOff';
  const COOKIE_YEARS = 10;
  const COUNTRY_KEY = 'vajaDetectedCountry';

  // US + territorios + AR (equipo).
  const USA_COUNTRIES = new Set(['US', 'AS', 'GU', 'MP', 'PR', 'UM', 'VI']);

  if (window.location.hostname.toLowerCase() !== USA_HOST) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (/bot|crawl|spider|slurp|lighthouse|inspection|preview|headless/i.test(navigator.userAgent)) return;

  function setRedirectOffCookie() {
    const expiration = new Date();
    expiration.setFullYear(expiration.getFullYear() + COOKIE_YEARS);
    document.cookie = [
      `${REDIRECT_COOKIE}=true`,
      `expires=${expiration.toUTCString()}`,
      'path=/',
      'domain=.vajacases.com',
      'SameSite=Lax',
      'Secure'
    ].join('; ');
  }

  function removeRedirectOffCookie() {
    document.cookie = [
      `${REDIRECT_COOKIE}=`,
      'expires=Thu, 01 Jan 1970 00:00:00 GMT',
      'path=/',
      'domain=.vajacases.com',
      'SameSite=Lax',
      'Secure'
    ].join('; ');
  }

  function hasRedirectOffCookie() {
    return document.cookie.split('; ').some((c) => c === `${REDIRECT_COOKIE}=true`);
  }

  const hash = window.location.hash.toLowerCase();

  if (hash === '#redirectoff') {
    setRedirectOffCookie();
    console.info('Vaja country redirect disabled for this browser.');
    return;
  }

  if (hash === '#redirecton') {
    removeRedirectOffCookie();
    console.info('Vaja country redirect enabled.');
  }

  if (hasRedirectOffCookie()) return;

  function redirectIfNeeded(country) {
    if (!country || USA_COUNTRIES.has(country)) return;

    const targetUrl = new URL(window.location.href);
    targetUrl.protocol = 'https:';
    targetUrl.hostname = ROW_HOST;
    targetUrl.port = '';
    // Marca para que ROW muestre el aviso de redirección (snippet vaja-redirect-notice).
    targetUrl.hash = 'from-us';

    window.location.replace(targetUrl.href);
  }

  // 1) País desde Liquid: confiable cuando NO es "US" (país con Market propio).
  const liquidCountry = String((window.VajaGeo && window.VajaGeo.country) || '').trim().toUpperCase();
  if (liquidCountry && liquidCountry !== 'US') {
    redirectIfNeeded(liquidCountry);
    return;
  }

  // 2) Liquid dice US (o nada): confirmar con el país real por IP.
  let cached = null;
  try { cached = sessionStorage.getItem(COUNTRY_KEY); } catch (e) { /* sin storage */ }

  if (cached) {
    redirectIfNeeded(cached);
    return;
  }

  fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      const country = String(
        (data && data.detected_values && data.detected_values.country && data.detected_values.country.handle) || ''
      ).toUpperCase();
      if (!country) return; // sin dato: no redirigir
      try { sessionStorage.setItem(COUNTRY_KEY, country); } catch (e) { /* sin storage */ }
      redirectIfNeeded(country);
    })
    .catch(() => { /* error de red: no redirigir */ });
})();